import Vue from 'vue'
import VueTailwind from 'vue-tailwind'
import 'tailwindcss/tailwind.css'
import TAlert from 'vue-tailwind/dist/t-alert'
import TButton from 'vue-tailwind/dist/t-button'
import TCard from 'vue-tailwind/dist/t-card'
import TInput from 'vue-tailwind/dist/t-input'
import TInputGroup from 'vue-tailwind/dist/t-input-group'
import TRadio from 'vue-tailwind/dist/t-radio'
import TSelect from 'vue-tailwind/dist/t-select'
import TTable from 'vue-tailwind/dist/t-table'

import Toggle, { defaultProps } from '@member-area/components/Toggle.vue'

const settings = {
  Toggle: {
    component: Toggle,
    props: defaultProps,
  },
  TCard: {
    component: TCard,
    props: {
      fixedClasses: {
        wrapper: 'border-2',
        body: 'p-3',
        header: 'border-b p-4',
        footer: 'border-t p-4',
      },
      classes: {
        wrapper: 'bg-white border-gray-100',
        body: '',
        header: 'border-gray-100',
        footer: 'border-gray-100',
      },
      variants: {
        danger: {
          wrapper: 'bg-red-50 text-red-700 border-red-200',
          header: 'border-red-200 text-red-700',
          footer: 'border-red-200 text-red-700',
        },
        large: {
          body: 'p-6',
        },
      },
    },
  },
  TAlert: {
    component: TAlert,
    props: {
      fixedClasses: {
        wrapper: 'relative flex items-center p-4 border-l-4  rounded shadow-sm',
        body: 'flex-grow',
        close:
          'absolute relative flex items-center justify-center ml-4 flex-shrink-0 w-6 h-6 transition duration-100 ease-in-out rounded focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50',
        closeIcon: 'fill-current h-4 w-4',
      },
      classes: {
        wrapper: 'bg-blue-50 border-blue-500',
        body: 'text-blue-700',
        close: 'text-blue-500 hover:bg-blue-200',
      },
      variants: {
        danger: {
          wrapper: 'bg-red-50 border-red-500',
          body: 'text-red-700',
          close: 'text-red-500 hover:bg-red-200',
        },
        success: {
          wrapper: 'bg-green-50 border-green-500',
          body: 'text-green-700',
          close: 'text-green-500 hover:bg-green-200',
        },
      },
    },
  },
  TInput: {
    component: TInput,
    props: {
      fixedClasses:
        'block px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes:
        'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-blue-500 ',
      variants: {
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success:
          'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
      },
    },
  },
  InputGroup: {
    component: TInputGroup,
    props: {
      fixedClasses: {
        wrapper: '',
        label: 'block',
        body: '',
        feedback: ' text-sm text-sm pt-2',
        description: 'text-gray-400 text-sm',
      },
      classes: {
        wrapper: '',
        label: '',
        body: '',
        feedback: 'text-gray-400',
        description: 'text-gray-400',
      },
      variants: {
        danger: {
          label: 'text-red-500',
          feedback: 'text-red-500',
        },
        success: {
          label: 'text-green-500',
          feedback: 'text-green-500',
        },
      },
    },
  },
  Button: {
    component: TButton,
    props: {
      fixedClasses:
        'block transition duration-100 ease-in-out focus:ring-2 focus:ring-blue-800 focus:outline-none focus:ring-opacity-50',
      classes:
        'min-w-200 px-4 py-2.5 text-white bg-primary text-base font-bold shadow-sm rounded-full hover:bg-gray-600 disabled:bg-grey disabled:text-primary disabled:cursor-not-allowed',
      variants: {
        secondary:
          'min-w-200 px-4 py-2.5 text-primary bg-white text-base rounded-full ring-inset ring-1 ring-black shadow-sm hover:text-gray-600',
        small:
          'whitespace-nowrap px-4 py-1 text-white bg-primary border border-transparent shadow-sm rounded-full hover:bg-gray-600 ',
        error:
          'text-white bg-red-500 border border-transparent rounded-full shadow-sm hover:bg-red-600',
        success:
          'text-white bg-green-500 border border-transparent rounded-full shadow-sm hover:bg-green-600',
        link: 'global-link',
        linkSecondary: 'secondary-link',
      },
    },
  },
  Select: {
    component: TSelect,
    props: {
      fixedClasses:
        'block bg-transparent w-full pl-3 pr-10 py-2 leading-loose transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed',
      classes:
        'text-black placeholder-gray-400 bg-white border-gray-300 focus:border-blue-500 ',
      variants: {
        danger: 'border-red-300 bg-red-50 placeholder-red-200 text-red-900',
        success:
          'border-green-300 bg-green-50 placeholder-gray-400 text-green-900',
      },
    },
  },
  Radio: {
    component: TRadio,
    props: {
      fixedClasses:
        'transition duration-100 ease-in-out shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 focus:ring-offset-0  disabled:opacity-50 disabled:cursor-not-allowed',
      classes: 'text-blue-500 border-gray-300',
      variants: {
        error: 'text-red-500 border-red-300',
        success: 'text-green-500 border-green-300',
      },
    },
  },
  Table: {
    component: TTable,
    props: {
      classes: {
        table:
          'min-w-full divide-y divide-gray-100 shadow-sm border-gray-200 border',
        thead: '',
        theadTr: '',
        theadTh: 'px-3 py-2 font-semibold text-left bg-gray-100 border-b',
        tbody: 'bg-white divide-y divide-gray-100',
        tr: '',
        td: 'px-3 py-2 whitespace-no-wrap',
        tfoot: '',
        tfootTr: '',
        tfootTd: '',
      },
      variants: {
        thin: {
          td: 'p-1 whitespace-no-wrap text-sm',
          theadTh: 'p-1 font-semibold text-left bg-gray-100 border-b text-sm',
        },
      },
    },
  },
}

Vue.use(VueTailwind, settings)

export default settings
